import React from 'react';
import Checkbox from './checkbox';

class Checkboxes extends React.Component {
  state = { values: [], loaded: false };

  componentDidMount() {
    // console.log(this.props, 'props');
    this.setState({ values: this.props.value || [], loaded: true });
  }

  handleChange = (event) => {
    // this.setState({ value: event.target.value });
    const name = event.target.name;
    const checked = event.target.checked;
    // Is it checked?
    if (checked) {
      // ensure this.state.values contains name
      if (this.state.values.indexOf(name) === -1) {
        let newArr = [];
        if (this.props.single) {
          newArr = [name];
        } else {
          newArr = [...this.state.values, name];
        }
        this.setState({ values: newArr });
        this.props.updateValue({ target: { value: newArr, name: this.props.name } });
      }
    }
    else {
      if (this.state.values.indexOf(name) !== -1) {
        const index = this.state.values.indexOf(name);
        let newArr = [...this.state.values];
        if (this.props.single) {
          newArr = [];
        } else {
          newArr.splice(index, 1);
        }
        // const newArr = [...this.state.values];
        this.setState({ values: newArr });
        this.props.updateValue({ target: { value: newArr, name: this.props.name } });
      }
    }
    // this.props.updateValue(state.value);
  }

  render() {
    const { field } = this.props;
    const { values, loaded } = this.state;
    // console.log(field, 'the field');
    if (!field || !loaded || !field.options || !field.options.length) {
      return null;
    }

    // Return a list of checkboxes, with each one tracking it's checked/unchecked state

    return (
      <div className="relative pb-1">
        {
          field.options.map(option => {
            const mockedField = {
              type: 'checkbox',
              label: option.label,
            };
            return (
              <Checkbox
                field={mockedField}
                updateValue={this.handleChange}
                name={option.value}
                submitting={this.props.submitting}
                key={option.value}
                value={values.indexOf(option.value) !== -1}
              />
            );
          })
        }
      </div>
    );
  }
};

export default Checkboxes;